<script>

</script>

<div class="contact-section">
    <div class="contact-container">
        <div class="contact-header">
            <h2 class="contact-title">Get In Touch</h2>
            <p class="contact-subtitle">Let's discuss opportunities or just say hello!</p>
        </div>
        <form action="https://formsubmit.co/4cc262a7fb7fef49105d9622b26194ec" method="POST" class="contact-form">
            <input type="hidden" name="_subject" value="New submission!">
            <input type="hidden" name="_autoresponse" value="Thank you for your email!">
            <input type="hidden" name="_next" value="https://www.joshuazheng.lol/">
            
            <div class="form-group">
                <label for="name">Name</label>
                <input name="name" type="text" id="name" required placeholder="Your full name" />
            </div>
            
            <div class="form-group">
                <label for="email">Email</label>
                <input name="email" type="email" id="email" required placeholder="your.email@example.com" />
            </div>
            
            <div class="form-group">
                <label for="number">Phone (Optional)</label>
                <input name="number" type="tel" id="number" placeholder="Your phone number" />
            </div>
            
            <div class="form-group">
                <label for="message">Message</label>
                <textarea name="message" id="message" rows="5" required placeholder="Tell me about your project or just say hello!"></textarea>
            </div>
            
            <button type="submit" class="submit-button">
                <span>Send Message</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                </svg>
            </button>
        </form>
    </div>
</div>

<style>
    .contact-section {
        padding: 1.5rem 0;
        max-width: 600px;
        margin: 0 auto;
    }

    .contact-container {
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 20px;
        padding: 2rem;
        backdrop-filter: blur(10px);
    }

    .contact-header {
        text-align: center;
        margin-bottom: 1.5rem;
    }

    .contact-title {
        font-size: 2.5rem;
        font-weight: 700;
        margin: 0 0 1rem 0;
        background: linear-gradient(135deg, #64b5f6, #42a5f5);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }

    .contact-subtitle {
        font-size: 1.1rem;
        color: #b0b0b0;
        margin: 0;
    }

    .contact-form {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
    }

    .form-group {
        display: flex;
        flex-direction: column;
    }

    label {
        font-weight: 500;
        margin-bottom: 0.5rem;
        color: #ffffff;
        font-size: 0.95rem;
    }

    input, textarea {
        padding: 1rem;
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.05);
        color: #ffffff;
        font-size: 1rem;
        font-family: inherit;
        transition: all 0.3s ease;
        backdrop-filter: blur(10px);
    }

    input::placeholder, textarea::placeholder {
        color: #888;
    }

    input:focus, textarea:focus {
        outline: none;
        border-color: #64b5f6;
        box-shadow: 0 0 0 3px rgba(100, 181, 246, 0.1);
        background: rgba(255, 255, 255, 0.08);
    }

    textarea {
        resize: vertical;
        min-height: 120px;
    }

    .submit-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 0.75rem;
        background: linear-gradient(135deg, #64b5f6, #42a5f5);
        color: #ffffff;
        border: none;
        padding: 1rem 2rem;
        border-radius: 12px;
        font-size: 1.1rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        margin-top: 1rem;
        align-self: center;
        min-width: 200px;
    }

    .submit-button:hover {
        background: linear-gradient(135deg, #42a5f5, #2196f3);
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(100, 181, 246, 0.3);
    }

    .submit-button:active {
        transform: translateY(0);
    }

    @media only screen and (max-width: 768px) {
        .contact-section {
            padding: 1.5rem 0;
        }

        .contact-container {
            padding: 2rem;
        }

        .contact-title {
            font-size: 2rem;
        }

        .contact-header {
            margin-bottom: 1.5rem;
        }
    }
</style>
